import React, { ReactNode } from "react";
import { MDXProvider } from "@mdx-js/react";
import { MDXComponents } from "./mdx-components";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <MDXProvider components={MDXComponents}>
      <main>{children}</main>
    </MDXProvider>
  );
};

export default Layout;
